import React from "react";
import "./ContactUs.css";

export const ContactUs = () => {
  return (
    <>
      <div className="bodyContent contactUs">
        <header>Contact Us</header>
        <div className="title">Phone Number: +852 6481 6406</div>
        {/* <div className="title">
          Email: <span className="email">info@kaitsz.com</span>
        </div>  */}
      </div>
    </>
  );
};
